import './Header.scss'

export default function Header() {
	return null;
}
